module.exports = __webpack_public_path__ + "static/img/code-pic.ae32056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code-pic.png
// module id = BJZv
// module chunks = 1